
import React, { PropsWithChildren, useContext } from 'react';
import { ROUTE_PARAMS, ROUTE_PATH } from '../../../utilities/navigation';
import { CreateListingPageView } from '../../../components/listing/creation/CreateListingPageView/CreateListingPageView';
import { Outlet, useNavigate } from 'react-router';
import { useParams } from 'react-router';
import { ListingCreationFlowContext, ListingCreationFlowProvider } from '../../../context/Listing';

/** The Page for the new listing flow */
export const NewListingPage = () => {
    const navigate = useNavigate();
    const { [ROUTE_PARAMS.listingID]: currentListingId, [ROUTE_PARAMS.flowStepID]: currentStepId, } = useParams();

    const navigateToStep = (newStepId: string, listingId?: string) => {
        if ((!listingId || listingId === currentListingId) && currentStepId === newStepId) {
            return;//if trying to go to the same link, just return
        }
        navigate("./" + (listingId || currentListingId) + "/" + newStepId);
    };

    const navigateToPublishSuccess = () => {
        navigate(ROUTE_PATH.listingPublishedBuild(currentListingId || ''))
    }

    return (
        <ListingCreationFlowProvider stepId={currentStepId} listingId={currentListingId}
            onStepId={navigateToStep}
            onPublished={navigateToPublishSuccess}>
            <CreateListingContainer>
                <Outlet />
            </CreateListingContainer>
        </ListingCreationFlowProvider>
    );
}

/** The Container which take care of the header and footer of the creation flow (taking info from the context to provide to the UI) */
const CreateListingContainer = ({ children }: PropsWithChildren<{}>) => {
    const flowContext = useContext(ListingCreationFlowContext);

    if (!flowContext) {
        throw new Error('Need ListingCreationFlowContext Provider')
    }

    const { steps, activeStep, handlePrev, handleNext, completed } = flowContext;

    return (
        <CreateListingPageView stepper={{
            steps,
            activeStep,
            handleNext,
            handlePrev,
            completed,
        }}>
            {children}
        </CreateListingPageView>
    );
}